module.exports = __webpack_public_path__ + "img/index3_5.b0c7825.png";